/**
 * 개인정보 처리방침 (Privacy Policy) - 한국어 v1
 * 
 * 원본: public/privacy.html (Pi Network 공식 제출본)
 * 한국어 번역본
 */
export const PRIVACY_V1_KO = {
    version: "v1",
    effectiveDate: "2025-10-15",
    language: "ko",
    title: "개인정보 처리방침",
    content: `
Spot Go 개인정보 처리방침

최종 업데이트: 2025년 10월 15일 (KST)

본 개인정보 처리방침은 Spot Go 개발자("개발자", "당사", "우리")가 귀하가 당사의 게임 Spot Go("서비스")를 이용할 때 귀하의 정보를 어떻게 수집, 이용, 공개하는지 설명합니다.

1. 수집하는 정보

당사는 서비스 운영 및 개선에 필요한 데이터만 수집하고 저장합니다.

1.1 Pi Network 계정 정보

귀하가 서비스에 로그인할 때 고유한 Pi Network 사용자 ID를 수신합니다. Pi Network 비밀번호는 수신하거나 저장하지 않습니다.

1.2 게임 내 식별 및 기록

Pi Network 로그인 과정을 통해 Pi Network 닉네임과 사용자 ID를 수신하여 계정 관리, 리더보드 랭킹, 결제 기록 목적으로 서버에 저장합니다. 이 정보는 게임플레이 데이터(점수, 구매 등)와 연결되지만 서비스 내에서 수정할 수 없습니다.

1.3 이용 데이터

사용자 경험 개선을 위해 분석 도구를 통해 귀하의 기기와 서비스 이용 방식에 대한 데이터를 수집할 수 있습니다.

2. 정보 이용 방법

• 서비스 제공 및 유지
• 계정 관리 및 게임 진행 저장
• 서비스 분석 및 개선
• 서비스 보안과 무결성 보호 및 치팅 방지

2-1. 닉네임의 공개 표시

랭킹 및 경쟁 기능을 제공하기 위해 귀하의 Pi Network 닉네임은 서비스 내 다른 사용자에게 공개적으로 표시될 수 있습니다(예: 리더보드 또는 랭킹). 이 정보는 서버에 안전하게 저장되지만 닉네임과 점수만 공개적으로 표시됩니다. 다른 개인 정보나 결제 세부 정보는 다른 사용자와 공유되지 않습니다.

3. 정보 공유

당사는 개인 정보를 판매하거나 임대하지 않습니다. 아래 설명된 경우에만 정보를 공유할 수 있습니다:

• 서비스 제공업체: 예를 들어 Firebase는 클라우드 호스팅 및 데이터베이스 관리에 사용됩니다.
• 법적 사유: 법률에서 요구하는 경우 또는 당사, 사용자, 타인의 권리, 재산, 안전을 보호하기 위해 정보를 공개할 수 있습니다.

4. 데이터 삭제

lukep81@painori.com으로 "데이터 삭제 요청" 제목으로 이메일을 보내 게임 데이터 삭제를 요청할 수 있습니다. 처리 시 모든 게임 데이터(진행 상황 및 점수 포함)가 영구적으로 삭제됩니다. 삭제 후 서비스에 다시 접속하면 새 프로필이 생성됩니다.

5. 데이터 보안 및 보관

합리적인 기술적, 조직적 조치를 사용하여 귀하의 데이터를 보호하지만, 인터넷을 통한 전송 방법은 100% 안전하지 않습니다. 계정이 활성 상태이거나 관련 법률에서 요구하는 동안에만 데이터를 보관합니다.

6. 국제 데이터 전송

귀하의 데이터는 귀하의 국가 외부의 서버로 전송되어 유지될 수 있습니다. 서비스를 이용함으로써 귀하는 이러한 전송에 동의합니다.

7. 아동의 개인정보

당사 서비스는 14세 미만의 아동을 대상으로 하지 않습니다. 아동의 데이터를 고의로 수집하지 않습니다. 그러한 데이터를 부주의하게 수집했음을 알게 되면 즉시 삭제합니다.

8. 문의하기

본 개인정보 처리방침에 대한 질문이 있으시면 다음으로 연락해 주세요: lukep81@painori.com
`.trim()
};
